export const LOCAL_PURCHASE_ORDER_LAYOUT_KEY = '0';

export const LOCAL_PURCHASE_ORDER_LAYOUT_NAME = 'Layout 0';

export interface IDocumentLayoutSummary {
  key: string;
  name: string;
}

export interface IDocumentLayoutOptions {
  accentColour?: string | null;
  columns?: string[];
  logoPosition?: 'left' | 'right';
  visibleBlocks?: string[];
}

export interface IPurchaseOrderLayoutSetting {
  layoutKey: string;
  options?: IDocumentLayoutOptions | null;
}

export interface IDocumentLayoutsDocument {
  purchaseOrder?: IPurchaseOrderLayoutSetting | null;
}
